<template>
  <div class="container o-newsletter">
    <div class="row">
      <div class="col-lg-8 d-none d-lg-block">
        <div class="o-newsletter__figure">
          <base-image
            v-if="$isNotNullOrUndefined(content.image[0])"
            :url="content.image[0].url"
            :width="909"
            :height="390"
            :ratio="909/390"
            :alt-text="content.imageAltText"
            image-class="o-newsletter__image"
          />
        </div>
      </div>
      <div class="col-lg-4">
        <div class="o-newsletter__background">
          <h1 v-if="content.headline" class="o-newsletter__headline">
            {{ content.headline }}
          </h1>
          <p v-if="content.description" class="o-newsletter__description">
            {{ content.description }}
          </p>
          <div class="o-newsletter__content" v-html="content.hTML">
            <!-- html -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import contentMixin from '@/mixins/contentMixin';
import BaseImage from '@/components/atoms/BaseImage';

export default {
  name: 'Newsletter',
  components: {
    BaseImage,
  },
  mixins: [contentMixin],
}
</script>
